<template>
<div>

  <div class="container">
  
    <header>
      <h3>{{content}}</h3>
    
    </header>

 <div class="row">
<div class="col-md-8 col-xs-12">
  
  <div class="videoNine clearfix">

              <div class="videoArea clearfix">
                <h3>Welcome To Sinai Portal</h3>
                <div class="row">
                  <div class="col-lg-8 col-md-7 col-xs-12 videoLeft">
                  <b-embed
    type="iframe"
    aspect="16by9"
    src="https://www.youtube.com/embed/xHdW90o1Okg"
    allowfullscreen
  ></b-embed>
                  </div><!-- videoLeft -->
                  <div class="col-lg-4 col-md-5 col-xs-12 videoRight">
                  <p>Sinai University was established refereeing to the presidential decree number 363 for year 2005 in accordance to provisions of law number 101 year 1992 regarding the private Universities which was replaced by law number 12 year 2009 regarding the private and civil Universities and its executive regulations issued by the presidential decree number 302 for year 2010..</p>
                  <a href="https://su.edu.eg/wp-content/uploads/2020/07/SU-company-profile-3.pdf" class="btn btn-block learnBtn">Learn More</a>
                  </div><!-- videoRight -->
                </div><!-- row -->
              </div><!-- videoArea -->

              <div class="related_post_sec single_post">
                <h3>Recent News</h3>
                <ul>
                  <li>
                    <span class="rel_thumb">
                      <a href="#"><img src="./../assets/related_thumb_01.png" alt=""></a>
                    </span><!--end rel_thumb-->
                    <div class="rel_right">
                      <h4><a href="https://su.edu.eg/index.php/2022/06/23/the-announcement-of-the-results/">The Announcement of The Results</a></h4>
                      <div class="meta">
                        <span class="author">Posted in: <a href="#">News</a></span>
                        <span class="date">on: <a href="#">June 23, 2022</a></span>
                      </div>
                      <p>The Faculty of Physical Therapy Sinai University is pleased to announce the results of
                        the spring semester to all the faculty levels. The faculty exams were ended Tuesday
                        21/6/2022 and all our student celebrated the last exam in the semester.</p>
                    </div><!--end rel right-->
                  </li>
                  <li>
                    <span class="rel_thumb">
                      <a href="#"><img src="./../assets/related_thumb_01.png" alt=""></a>
                    </span><!--end rel_thumb-->
                    <div class="rel_right">
                      <h4><a href="https://su.edu.eg/index.php/2022/06/20/emg-biofeedback-workshop-training/">EMG Biofeedback Workshop Training
</a></h4>
                      <div class="meta">
                        <span class="author">Posted in: <a href="#">News</a></span>
                        <span class="date">on: <a href="#">June 20, 2022</a></span>
                      </div>
                      <p>Under the auspices of Prof. Dr. Hala Ezzeldeen, the dean of the faculty of physical
therapy, and Prof. Dr. Fatma Aboelmaged, the faculty vice dean; and under the
supervision of Assist. Prof. Dr. Salaheldien Raslan the head of basic sciences
department the faculty of physical therapy organized an EMG Biofeedback workshop
for training staff members and teaching assistances to operate on the device.
</p>
                    </div><!--end rel right-->
                  </li>
                </ul>
              </div><!--related_post_sec-->

          </div>
</div>
<div class="col-md-4 col-xs-12">

<div class="list_block related_post_sec">
              <div class="upcoming_events">
                <h3>Upcoming Events</h3>
                <ul>
                  <li class="related_post_sec single_post">
                    <span class="date-wrapper">
                      <span class="date"><span>08</span>Dec</span>
                    </span>
                    <div class="rel_right">
                      <h4><a href="#">global-forum-for-higher-education-and-scientific-research</a></h4>
                      <div class="meta">
                        <span class="place"><b-icon icon="map" ></b-icon> Main Campus</span>
                        <span class="event-time"><b-icon icon="clock-fill" ></b-icon> 11.00 pm</span>
                      </div>
                    </div>
                  </li>
                  <li class="related_post_sec single_post">
                    <span class="date-wrapper">
                      <span class="date"><span>13</span>Oct</span>
                    </span>
                    <div class="rel_right">
                      <h4><a href="#">Registration of compulsory and elective internship doctors for the batch of 160 dental college</a></h4>
                      <div class="meta">
                        <span class="place"><b-icon icon="map" ></b-icon> Arish Campus</span>
                        <span class="event-time"><b-icon icon="clock-fill" ></b-icon> 11.00 pm</span>
                      </div>
                    </div>
                  </li>
                  <li class="related_post_sec single_post">
                    <span class="date-wrapper">
                      <span class="date"><span>15</span>Dec</span>
                    </span>
                    <div class="rel_right">
                      <h4><a href="#">sign language session kantaraa campus</a></h4>
                      <div class="meta">
                      <span class="place"><b-icon icon="map" ></b-icon> Kantara Campus</span>
                        <span class="event-time"><b-icon icon="clock-fill" ></b-icon> 11.00 am</span>
                      </div>
                    </div>
                  </li>
                </ul>
                <a href="https://su.edu.eg/index.php/news__events/" class="btn btn-default btn-block commonBtn">More Events</a>
              </div>
            </div>



</div>

 </div>

  </div>
 
</div>
</template>

<script>
import ApplicantDataServices from '../services/Applicant/ApplicantData.services';
//import UserService from '../services/user.service';

export default {
  beforeCreate: function () {
     document.body.className = 'body';
    },

  name: 'Home',
  components:{
  
  },
  data() {
    return {
      content: '',
      dismissSecs: 60,
        dismissCountDown: 0,
        showDismissibleAlert: false
    };
  },
  methods: {
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert() {
        this.dismissCountDown = this.dismissSecs
      }
    },
  mounted() {
    // UserService.getPublicContent().then(
    //   response => {
    //     this.content = response.data;
    //   },
    //   error => {
    //     this.content =
    //       (error.response && error.response.data) ||
    //       error.message ||
    //       error.toString();
    //   }
    // );
    ApplicantDataServices.CheckApplicantIsStudent(this.currentUser.UserIDSerial).then(response=>{
     if( Array.isArray(response.data)){
       this.dismissCountDown = 60
       this.showDismissibleAlert =true,
       localStorage.student =JSON.stringify( response.data )
       setTimeout(()=>{
         this.$router.push('/CreateStudentAccount')
       },60000)
     }
    }, error => {
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
        if (error.response.status == 404) this.message = ''
      })
  },
  computed:{
         currentUser() {
        return this.$store.state.auth.user
      },

  }
};
</script>
<style scoped>
body{
    background:#E4EAF6 ;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 24px;
    color: #545454;
}
.body{
  background:#E4EAF6 ;
}

.videoArea {
    margin-bottom: 27px;
    padding-bottom: 30px;
    border-bottom: 1px solid #dce4ea;
}

h1, h2, h3, h4 {
    font-family: 'Roboto Slab', serif;
    font-weight: 700;
    color: #282428;
    margin: 0;
}
h3 {
    margin-bottom: 30px;
    font-size: 18px;
    text-transform: uppercase;
}

.videoRight > p {
    margin: 0 0 15px 0;
}

.single_post.related_post_sec h4 a {
    font-size: 16px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.6);
    line-height: 21px;
    margin: 0 0 8px;
    text-decoration: none;
}
.videoNine {
    padding-right: 30px;
    border-right: 1px solid #d6d6d6;
}

.list_block, .sidebar_item, .formArea {
    border-top-color: #49c32c;
}

.list_block {
    border: 1px solid #c5cace;
    padding: 15px 12px 25px;
    border-top: 3px solid #49c32c;
    margin: 0 0 20px;
}

.related_post_sec h3 {
    font-size: 22px;
}
.upcoming_events .related_post_sec.single_post {
    margin-bottom: 70px;
    position: relative;
    float: left;
}

.upcoming_events li.related_post_sec.single_post {
    float: none;
    margin-bottom: 16px;
}

.upcoming_events .related_post_sec.single_post .date-wrapper {
    position: absolute;
    top: 0;
    left: 0;
}

.upcoming_events .related_post_sec.single_post span.date {
    display: block;
    margin-right: 20px;
}
.upcoming_events span.date {
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    transition: color 0.3s;
    padding: 5px 0;
    border: 3px solid #dce4ea;
    display: inline-block;
    width: 70px;
    text-align: center;
    margin-right: 10px;
}

.upcoming_events span.date span {
    font-weight: 700;
    font-size: 36px;
    display: block;
    line-height: 30px;
}

.upcoming_events .related_post_sec.single_post .rel_right {
    padding-left: 90px;
    float: left;
}
.rel_right h4 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
}

.single_post.related_post_sec .meta > span {
    border: none;
}
.upcoming_events ul li:hover span.date,.upcoming_events .related_post_sec.single_post:hover span.date {
    color: #49c32c;
}

.related_post_sec ul li {
    padding: 0 0 6px;
    margin: 0 0 18px;
    border-bottom: 1px solid #bcc2c6;
    display: block;
    clear: both;
    width: 100%;
    float: left;
}

.upcoming_events ul li {
    display: table;
    float: none;
    position: relative;
}

.upcoming_events .meta span, .single-event .meta span {
    font-size: 13px;
    color: rgba(0, 0, 0, 0.5);
    font-weight: 400;
    font-style: normal;
    line-height: 20px;
    padding-right: 0;
    margin-right: 25px;
    border-right: none;
}
.container-fluid{


      
      

      padding: 0px !important;
      margin-top: -3rem !important;
}

.home{
  padding: 100px 20px;
  text-align: center;
  position: relative;
}
.home img{
width: 100%;
}

.btn.learnBtn {
    padding: 0;
    height: 42px;
    border: 1px solid #0060b1;
    background: #0060b1;
    border-radius: 0;
    line-height: 42px;
    color: #ffffff;
    text-transform: uppercase;
    font-weight: 400;
}

.single_post.related_post_sec .rel_thumb {
    margin-right: 20px;
    width: 34%;
  float: left;
    height: auto;
    margin: 5px 10px 0 0;
}

ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.rel_right h4 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
}

.single_post.related_post_sec .meta {
    padding: 0;
    border: none;
    margin: 0 0 15px;
}

.meta span {
    font-weight: 400;
    font-style: italic;
    line-height: 20px;
    display: inline-block;
    padding-right: 20px;
    margin-right: 10px;
    border-right: 1px solid #dce4ea;
}

.meta span a {
    color: #49c32c;
    text-decoration: none;
    font-weight: 400;
}

.user-bg{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border:2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  top:22%;
      left: 12%;
    font-size: 3rem;
    color: #fff;
}

.user-bg h1{
  font-size: 1.8rem;
  color: #fff;
      margin-bottom: -10px;
    left: -26px;
    position: absolute;

}

.user-bg2 h1{
  font-size: 1.8rem;
  color: #fff;
      margin-bottom: -10px;
    left: -26px;
    position: absolute;

}

.user-bg3 h1{
  font-size: 1.8rem;
  color: #fff;
      margin-bottom: -10px;
    left: -20px;
    position: absolute;

}

.user-bg4 h1{
  font-size: 1.8rem;
  color: #fff;
      margin-bottom: -10px;
    left: -6px;
    position: absolute;

}


.user-bg2{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border:2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  top:22%;
      right: 12%;
    font-size: 3rem;
    color: #fff;
}
.user-bg3{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border:2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  bottom:22%;
      left: 12%;
    font-size: 3rem;
    color: #fff;
}

.user-bg4{
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #EDBD88;
  border:2px solid #fff;
  text-align: center;
  position: absolute;
  z-index: 2;
  bottom:22%;
      right: 12%;
    font-size: 3rem;
    color: #fff;
}

.active{
  border:2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.user-bg:hover{
    border:2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}
.user-bg2:hover{
    border:2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}

.user-bg3:hover{
    border:2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}
.user-bg4:hover{
    border:2px solid #00A1D5 !important;
  color: #00A1D5 !important;
}
.alert-dismissible{
      margin-top: 00px;

}

.commonBtn {
    padding: 0;
    background-color: #49c32c;
    text-transform: uppercase;
    color: #fff;
    border-color: #49c32c;
    height: 42px;
    line-height: 42px;
    font-weight: 700;
}
@media screen and (max-width : 400px) {
  .single_post.related_post_sec .rel_thumb {
    
    width: 100%;
  
}
img{
  width : 69vw !important
}
}
@import url('../assets/style.css');
</style>